import apiCustomer from '@/api/customer';
import apiOption from '@/api/option';

const defaultState = () => ({
	listCustomer: [],
	customerPagination: '',
	detailCustomer: '',
  promoResults: [],
	requirement: [],
	customerArea: [],
	dataGS: {},
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
	setCustomer(state, data) {
		state.listCustomer = data.data
		state.customerPagination = data.pagination;
	},
	setDetailCustomer(state, data) {
		state.detailCustomer = data
	},
  setPromo77(state, data) {
		state.promoResults = data
	},
  setPromoSept2022(state, data) {
		state.promoResults = data
	},
	setRequirement(state, data) {
		state.requirement = data
	},
	setCustomerArea(state, data) {
		state.customerArea = data
	},
	setDataGS(state, data) {
		state.dataGS = data
	},
	saveResponse(state, data) {
		state.response = data
		state.responseError = {}
		state.alert = ''
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataCustomer(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getCustomer({ commit, dispatch }, params) {
		apiCustomer.getDataCustomer(params).then(({ data: { data } }) => {
			commit('setCustomer', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setCustomer', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	getCustomerDetail({ commit, dispatch }, params) {
		return new Promise((resolve) => {
			apiCustomer.getDetailCustomer(params).then(({ data: { data } }) => {
				commit('setDetailCustomer', data.results);
				resolve()
			}).catch((err) => {
				commit('setDetailCustomer', {});
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	async addCustomer({ dispatch }, params) {
		await apiCustomer.addCustomer(params).then(res => {
			const data = res.data;
			dispatch('success', data)
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	updateCustomer({ dispatch }, params) {
		return new Promise(async (resolve, reject) => {
			await dispatch('isAttempting', null, { root: true })
			await apiCustomer.updateCustomer(params).then(res => {
				const data = res.data;
				dispatch('success', data)
				resolve()
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
				reject()
			});
			await dispatch('attempted', null, { root: true })
		})
	},
	updatePasswordCustomer({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCustomer.updatePasswordCustomer(params).then(res => {
				const data = res.data;
				dispatch('success', data)
				resolve()
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
				reject()
			});
		})
	},
	async rejectCustomer({ dispatch }, params) {
		await apiCustomer.rejectCustomer(params).then(res => {
			const data = res.data;
			dispatch('success', data)
		}).catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	getOptionProvince({ dispatch }) {
		return new Promise((resolve) => {
			apiOption.getOptionProvince().then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionCity({ dispatch }, params) {
		return new Promise((resolve) => {
			apiOption.getOptionCity({province_id: params}).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch((err) => {
				resolve([]);
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getOptionSubdistrict({ dispatch }, params) {
		return new Promise((resolve) => {
			apiOption.getOptionSubdistrict({city_id: params}).then(({ data: { data } }) => {
				resolve(data.results);
			}).catch((err) => {
				resolve([]);
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	getRegistrationRequirements({ commit, dispatch }) {
		apiOption.getRegistrationRequirements().then(({ data: { data } }) => {
			commit('setRequirement', data.results);
		}).catch((err) => {
			commit('setRequirement', []);
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	getCustomerArea({ commit, dispatch }, params) {
		apiCustomer.getCustomerArea(params).then(({ data: { data } }) => {
			commit('setCustomerArea', data.results);
		}).catch((err) => {
			commit('setCustomerArea', []);
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	async checkgs({ commit, dispatch }, params) {
		await dispatch('isAttempting', null, { root: true })
		await commit('setDataGS', {});
		await apiCustomer.checkgs(params).then(({ data: { data } }) => {
			commit('setDataGS', data.results);
		}).catch((err) => {
			commit('setDataGS', {});
			const data = err.response.data
			dispatch("errorHandler", data)
		});
		await dispatch('attempted', null, { root: true })
	},
	async exportCustomer({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiCustomer.exportCustomer(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Pelanggan'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	loginSsoPOS({ dispatch }, params) {
		return new Promise((resolve) => {
			apiCustomer.loginSsoPOS(params).then(res => {
				const data = res.data;
				resolve(data.data)
				dispatch('success', data)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
			});
		})
	},
	updateStatus({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiCustomer.updateStatus(params).then(res => {
				const data = res.data;
				dispatch('success', data)
				resolve()
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data)
				reject()
			});
		})
	},
  getPromo77({ commit, dispatch }) {
		apiCustomer.getDataPromo77().then(({ data: { data } }) => {
			commit('setPromo77', data.results);
		}).catch((err) => {
			commit('setPromo77', []);
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
  getPromoSept2022({ commit, dispatch }) {
		apiCustomer.getDataPromoSept2022().then(({ data: { data } }) => {
			commit('setPromoSept2022', data.results);
		}).catch((err) => {
			commit('setPromoSept2022', []);
			const data = err.response.data
			dispatch("errorHandler", data)
		});
	},
	success({ commit }, data) {
		commit("saveResponse", data);
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.message
			}, { root: true });
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
